import faunadb, { Collection, Update } from "faunadb";
const q = faunadb.query;
const { Call,Paginate,Match,Index,Lambda,Get,Var,Map,Ref } = q;

const ADD_TEACHER = async (client, name, email, password, icon, setClient) => {
  try {
    let response = await client.query(
      Call(q.Function("add_teacher"), {
        name: name,
        email: email,
        password: password,
        deleted: false,
        icon: icon,
      })
    );
    return response;
  } catch (error) {
    throw Error(error.requestResult.responseRaw);
  }
};

export const getAllTeachers = async (client) => {
  try {
    let response = await client.query(
      Map(
        Paginate(Match(Index("allTeachers")), { size: 999 }),
        Lambda('teacherRef', Get(Var('teacherRef')))
      )
    );
    return response;
  } catch (error) {
    console.log(error);
    throw Error(error.requestResult.responseRaw);
  }
};

export const deleteTeacher = async(client,id) =>{
  try{
    let response = await client.query(
      Update(
        Ref(Collection("Teacher"),id),{
          data:{
            deleted:true
          }
        }
      )
    );
    return response;
  }
  catch(error){
    console.log(error);
    throw Error(error.requestResult.responseRaw);
  }
}

const exportItems = { ADD_TEACHER };

export default exportItems;
